import React, { Component } from "react";
import { studentFiveHourData } from "../../data/loaders";
import { ProcessFiveHourData } from "../../data/process";
import StudentTable from "../core/StudentTable";
import { PageWrapper } from "./LessonDashboard";
import SectionHeader from "../core/style/SectionHeader";
import BackButton from "../core/BackButton";
const headers = ["Date Taken", "Certificate #", "Expiration", "Class Cost"];

class FiveHourDashboard extends Component {
  state = {
    data: null,
    loading: true
  };
  async componentDidMount() {
    this.props.updateMenu("fivehour", "5hr. Class Info");
    const apiData = await studentFiveHourData();
    const data = ProcessFiveHourData(apiData);
    this.setState({ data, loading: false });
  }
  render() {
    if (this.state.loading) return <h4>Loading Classes </h4>;
    return (
      <PageWrapper>
        <BackButton path="/app/student-dashboard" />
        <SectionHeader>5hr.Class Info</SectionHeader>
        {this.state.data.length > 0 ? (
          <StudentTable headers={headers} data={this.state.data} />
        ) : (
          <p>No 5hr. Class Information Available.</p>
        )}
      </PageWrapper>
    );
  }
}

export default FiveHourDashboard;
